import type { ReactNode } from "react";
import { Loader2 } from "lucide-react";

/** Um bloco da seção Dados (nome, cadastro, endereço, prazo), com borda própria pra ficar lado a
 *  lado com os outros no desktop. */
export function BlocoDeDados({ titulo, descricao, children }: { titulo?: string; descricao?: string; children: ReactNode }) {
  return (
    <section className="space-y-3 rounded-lg border border-zinc-200 p-4 dark:border-border">
      {titulo && (
        <div>
          <h3 className="text-sm font-semibold text-zinc-900 dark:text-foreground">{titulo}</h3>
          {descricao && <p className="mt-1 text-[12.5px] text-zinc-500 dark:text-muted-foreground">{descricao}</p>}
        </div>
      )}
      {children}
    </section>
  );
}

export function BotaoSalvar({ onClick, disabled, salvando, title }: { onClick: () => void; disabled: boolean; salvando: boolean; title?: string }) {
  return (
    <div className="flex justify-end">
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        title={title}
        className="inline-flex h-11 items-center gap-1.5 rounded-md bg-brand-600 px-4 text-[12.5px] font-semibold text-white shadow-sm transition-colors hover:bg-brand-700 disabled:opacity-50 sm:h-9"
      >
        {salvando && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
        Salvar
      </button>
    </div>
  );
}
